import { useEffect, useState } from "react";
import styles from "./peopleInvestination.module.css";
import UserInfo from "../../../Components/UserInfo/UserInfo";
import { OFFERS } from "../../../../../Api/Api";
import { Axios } from "../../../../../Api/Axios";
import Payment from "../../../Components/Payment/Payment";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function InvestorProfile() {
  const defaultProfileImage = require("../../../../../Assets/Images/profile.jpg");
  const [offersData, setOffersData] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);

  useEffect(() => {
    const getOffers = async () => {
      try {
        const res = await Axios.get(`${OFFERS}/sent`);
        setOffersData(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getOffers();
  }, []);

  const handlePaymentClick = (offer) => {
    setSelectedOffer(offer);
  };

  const handlePaymentSuccess = () => {
    setSelectedOffer(null);
    // Refresh the offers list
    const getOffers = async () => {
      try {
        const res = await Axios.get(`${OFFERS}/sent`);
        setOffersData(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getOffers();
  };

  const handleCloseModal = () => {
    setSelectedOffer(null);
  };

  const mapOffers = offersData.map((offer) => {
    const decodedImage = `data:image/jpeg;base64,${offer.talent.profilePicture}`;
    return (
      <div key={offer.id} className={`${styles.card} card shadow-lg mb-4`}>
        <div
          className={`${styles.cardBody} card-body d-flex align-items-center justify-content-between gap-5 p-relative`}
        >
          <div style={{ width: "100%" }}>
            <div>
              <div className="d-flex align-items-center gap-4">
                <img
                  width={80}
                  height={80}
                  src={
                    offer.talent.profilePicture
                      ? decodedImage
                      : defaultProfileImage
                  }
                  alt="profile"
                  style={{ borderRadius: "50%", objectFit: "contain" }}
                />
                <span style={{ color: "#3d3d3d" }}>{offer.talent.name}</span>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <p
              className={`badge m-0 ${
                offer.status === "pendingAdminApproval"
                  ? "text-bg-warning"
                  : offer.status === "adminAccepted"
                  ? "text-bg-success"
                  : offer.status === "adminRejected"
                  ? "text-bg-danger"
                  : offer.status === "talentRejected"
                  ? "text-bg-danger"
                  : "text-bg-primary"
              }`}
            >
              {offer.status === "pendingAdminApproval"
                ? "Offer Pending By Admin"
                : offer.status === "adminAccepted"
                ? "Offer Accepted By Admin"
                : offer.status === "adminRejected"
                ? "Offer Rejected By Admin"
                : offer.status === "talentRejected"
                ? "Offer Rejected By Talent"
                : "Talent Accepted"}
            </p>
            {offer.status === "talentAccepted" && !offer.is_paid && (
              <button
                onClick={() => handlePaymentClick(offer)}
                className="btn btn-primary"
                style={{ backgroundColor: "#7939FF", width: "100px" }}
              >
                Pay Now
              </button>
            )}
          </div>
        </div>
      </div>
    );
  });

  return (
    <>
      <UserInfo />

      <div className={`${styles.second} shadow-lg`}>
        <h2>People Investination</h2>
        {mapOffers}
      </div>

      {selectedOffer && (
        <div className={styles.paymentModal}>
          <div
            className={styles.paymentModalContent}
            onClick={(e) => e.stopPropagation()}
            style={{ position: "relative" }}
          >
            <button className={styles.closeButton} onClick={handleCloseModal}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
            <Payment offer={selectedOffer} onSuccess={handlePaymentSuccess} />
          </div>
        </div>
      )}
    </>
  );
}
